export enum Status {
  BURN = "BURN",
  SILENCE = "SILENCE",
  FATIGUE = "FATIGUE",
  POISONNED = "POISONNED",
  FREEZE = "FREEZE",
  PROTECT = "PROTECT",
  SLEEP = "SLEEP",
  CONFUSION = "CONFUSION",
  CHARM = "CHARM",
  FLINCH = "FLINCH",
  WOUND = "WOUND",
  RAGE = "RAGE",
  RESURRECTION = "RESURRECTION",
  RESURRECTING = "RESURRECTING",
  PARALYSIS = "PARALYSIS",
  POKERUS = "POKERUS",
  ARMOR_BREAK = "ARMOR_BREAK",
  RUNE_PROTECT = "RUNE_PROTECT",
  CURSE = "CURSE",
  ELECTRIC_FIELD = "ELECTRIC_FIELD",
  PSYCHIC_FIELD = "PSYCHIC_FIELD",
  GRASS_FIELD = "GRASS_FIELD",
  FAIRY_FIELD = "FAIRY_FIELD",
  SPIKY_SHIELD = "SPIKY_SHIELD",
  MAGIC_BOUNCE = "MAGIC_BOUNCE",
  REFLECT = "REFLECT",
  LOCKED = "LOCKED",
  POSSESSED = "POSSESSED",
  BLINDED = "BLINDED"
}

export const PositiveStatuses = [
  Status.POKERUS,
  Status.RESURRECTION,
  Status.RUNE_PROTECT,
  Status.PROTECT,
  Status.ELECTRIC_FIELD,
  Status.PSYCHIC_FIELD,
  Status.GRASS_FIELD,
  Status.FAIRY_FIELD,
  Status.SPIKY_SHIELD,
  Status.MAGIC_BOUNCE,
  Status.REFLECT,
  Status.RAGE
]
